import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import CustomTable from "../../../uiKit/CustomTable/customTable";
import RowRenderer from '../../Campaigns/campaignRow';
import RowRendererUser from "../../Campaigns/campaignRowUser";
import NoDonations from "./noDonations";

import { getCommunityDonations } from "../../../redux/state/paymentSlice";

const RecentDonationsTableOurBalance = ({ includeCampaigns = false }) => {
    const { pathname } = useLocation();

    const [paginationDataDonations, setPaginationDataDonations] = useState({
        pageSize: 8,
        page: 1
    });

    const communityId = useSelector(state => state.community.community.id, shallowEqual);
    const donations = useSelector(state => state.payment.donations, shallowEqual);
    const isAdmin = useSelector(state => state.community.community.role, shallowEqual);

    const isLoading = useSelector(state => state.payment.isLoading.getCommunityDonations, shallowEqual);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!!paginationDataDonations && !!communityId) {
            dispatch(getCommunityDonations({
                ...paginationDataDonations,
                communityId,
                isAdmin,
                includeCampaigns,
            }))
        }
    }, [
        paginationDataDonations,
        communityId,
        isAdmin,
        includeCampaigns,
        dispatch,
    ]
    )

    const adminHeader = [
        { name: '' },
        { name: 'Name' },
        { name: 'Operation time' },
        { name: 'Amount' },
        { name: 'Anonymous' }
    ];

    const userHeader = [
        { name: '' },
        { name: 'Name' },
        { name: 'Amount' },
    ]

    return (
        !!donations && !!donations.items && !!donations.items.length ? (
            <div className='donationTable'>
                <CustomTable
                    RowRenderer={isAdmin ? RowRenderer : RowRendererUser}
                    headerArray={isAdmin ? adminHeader : userHeader}
                    data={donations}
                    url={pathname}
                    isLoading={isLoading}
                    setPaginationData={setPaginationDataDonations}
                    scrollToY={500}
                />
            </div>
        ) : (
            <div className="displayNone">
                <NoDonations />
            </div>
        )
    )
}

export default RecentDonationsTableOurBalance;